import axios from "axios"
import {configManager, Result, routerManager} from "@zhoujianhui/vip-core"
import routeMapper from "../mapper/route-mapper"

const routeService = {
    // 含有未被配置为菜单的路由
    async getRouteTree() {
        try {
            const response = await axios.get(`${configManager.getConfig().iam.contextPath}/routes`)
            const routeTree = this.foldRoutesToRouteTree(response.data);

            return Result.success("获取路由树成功！").data(routeTree).build()
        } catch (error) {
            return Result.error(`获取路由树失败！具体原因：${error.message}`).build()
        }
    },

    async addRoute(addedRoute) {
        try {
            await axios.post(`${configManager.getConfig().iam.contextPath}/routes`, routeMapper.toSaveDto(addedRoute))

            return Result.success("新增路由成功！").build()
        } catch (error) {
            return Result.error(`新增路由失败！具体原因：${error.message}`).build()
        }
    },
    async editRoute(editedRoute) {
        try {
            await axios.put(`${configManager.getConfig().iam.contextPath}/routes/${editedRoute.id}`, routeMapper.toSaveDto(editedRoute))

            return Result.success("编辑路由成功！").build()
        } catch (error) {
            return Result.error(`编辑路由失败！具体原因：${error.message}`).build()
        }
    },
    async deleteRoute(id) {
        try {
            await axios.delete(`${configManager.getConfig().iam.contextPath}/routes/${id}`)

            return Result.success("删除路由成功！").build()
        } catch (error) {
            return Result.error(`删除路由失败！具体原因：${error.message}`).build()
        }
    },

    async syncRoute() {
        const routeTree = await routerManager.getFrontendRoutes()
        const flatRoutes = this.flattenRouteTreeToRoutes("", routeTree)

        try {
            const response = await axios.put(`${configManager.getConfig().iam.contextPath}/routes`, routeMapper.toSyncDtos(flatRoutes))

            return response.data.affectedNum > 0 ?
                Result.success("同步路由成功！").build() :
                Result.warning("没有新的路由需要同步！").build()
        } catch (error) {
            return Result.error("同步路由失败！" + error.message).build()
        }
    },

    //////

    foldRoutesToRouteTree(routes) {
        for (const route of routes) {
            if (route.parentRouteId) {
                for (const treeRoute of routes) {
                    if (treeRoute.id === route.parentRouteId) {
                        if (treeRoute.children === undefined) treeRoute.children = []
                        treeRoute.children.push(route)
                    }
                }
            }
        }

        return routes.filter(route => !route.parentRouteId)
    },
    flattenRouteTreeToRoutes(parentRoutePath, routeTree) {
        let routes = []

        routeTree.forEach(routeTreeNode => {
            const route = {
                path: routeTreeNode.path,
            }

            if (parentRoutePath) {
                route.parentRoutePath = parentRoutePath
            }

            routes.push(Object.assign(route, routeTreeNode.meta))

            if (routeTreeNode.children) {
                routes = routes.concat(this.flattenRouteTreeToRoutes(routeTreeNode.path, routeTreeNode.children))
            }
        })

        return routes
    }
}

export default routeService